__turbopack_context__.v({
  "hide": "UpNext-module-scss-module__PwC9ha__hide",
  "upNext": "UpNext-module-scss-module__PwC9ha__upNext",
  "upNextClipDuration": "UpNext-module-scss-module__PwC9ha__upNextClipDuration",
  "upNextClipOwner": "UpNext-module-scss-module__PwC9ha__upNextClipOwner",
  "upNextClipTitle": "UpNext-module-scss-module__PwC9ha__upNextClipTitle",
  "upNextDescription": "UpNext-module-scss-module__PwC9ha__upNextDescription",
  "upNextHeader": "UpNext-module-scss-module__PwC9ha__upNextHeader",
  "upNextPlayIcon": "UpNext-module-scss-module__PwC9ha__upNextPlayIcon",
  "upNextProgressBar": "UpNext-module-scss-module__PwC9ha__upNextProgressBar",
  "upNextProgressContainer": "UpNext-module-scss-module__PwC9ha__upNextProgressContainer",
  "upNextThumbnailContainer": "UpNext-module-scss-module__PwC9ha__upNextThumbnailContainer",
  "upNextThumbnailImage": "UpNext-module-scss-module__PwC9ha__upNextThumbnailImage",
});
